export default function SettingsContentContainer({children, className, style = {}}) {
    return (
        <div className={`${className} device-settings-sub-container`} style={style}>
            {children}
        </div>
    )
}